import React, { Component } from 'react';
import ReactAudioPlayer from 'react-audio-player';


class AudioItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            imageId: ''

        };

    }


    componentDidMount() {
        /*this.props.getGalleryInfo();
        let imgIndex = this.props.galleryInfo.imgIndex;
        this.setState({'imgIndex' : imgIndex});*/
    }

    render() {
        let image = this.props.item;
       // let itemIndex = this.props.iteration;
        // let imgpath = IMGIX_PATH +'assets/slider/'+ image.img_name+'?fit=crop&h=500&w=800&auto=enhance&dpr=3%203x';

        let audioPath = image.img_path;
      //  let defImgSrc = require("../../../assets/images/no-image.jpg");
        /*let im_class = "carousel-item ";


        console.log("itemIndex"+itemIndex);

        if(itemIndex == this.state.imgIndex ) {
            im_class += "active";
        }*/


        let elId = "audio"+this.props.id;

        return (

                <ReactAudioPlayer id={elId} className="audioPlayer"
                    src= {audioPath}
                    controls
                />
        );
    }


}


/*function mapStateToProps(state) {

    return {
        galleryInfo  :galleryReducers.setGalleryUpdate(state)
    };

}
export default  withRouter(connect(mapStateToProps, {
    getGalleryInfo : galleryActions.getImgId
})(ImageItem));*/

export default AudioItem;




// WEBPACK FOOTER //
// ./src/components/includes/Slider/AudioItem.js